import { render, staticRenderFns } from "./BankAccountBalanceSettingForm.vue?vue&type=template&id=6bb3c4c8&"
import script from "./BankAccountBalanceSettingForm.vue?vue&type=script&lang=js&"
export * from "./BankAccountBalanceSettingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports